import { useSession } from "@outschool/ui-auth";
import { useExperiment } from "@outschool/ui-experiments";
import { useEffect } from "react";

const EXPERIMENT_NAME = "AutosuggestEmptyQueryV1";

/**
 * Experiment hook for the AutosuggestEmptyQueryV1 experiment. This should be used to determine
 * if the new placeholder suggestions should be shown in the autosuggest dropdown when the query is empty.
 */
export default function useAutosuggestEmptyQueryV1Experiment() {
  const { currentUserHasLoaded } = useSession();

  const { variant, trigger } = useExperiment({
    currentUserHasLoaded,
    experimentName: EXPERIMENT_NAME,
  });

  // Trigger the experiment immediately when the hook is used
  useEffect(() => {
    trigger();
  }, [trigger]);

  return {
    useNewPlaceholderSuggestions: variant === "treatment",
  };
}
